import { z } from "zod";

export const bigNumberTransformer = z
  .string()
  .or(z.number())
  .or(z.null())
  .transform((val, ctx) => {
    if (val === null) {
      return 0;
    }
    if (typeof val === "number") {
      return val;
    }

    const num = Number(val);
    if (isNaN(num)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Invalid number string",
      });
      return z.NEVER;
    }
    return num;
  })
  .default(0);
